export default "__VITE_ASSET__CLcF$rdX__"